module.exports = __webpack_public_path__ + "img/courier_dire_flying.006b063b.png";